/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { RestApiOptions } from './types';

export const createExchangeRatesRepository = (options: RestApiOptions): Types.ExchangeRatesRepository => ({
    async getAll(params, requestOptions) {
        return options.request('/exchangeRates/getAll', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
